export const FETCH_POA_LIST   = 'FETCH_POA_LIST';